const initialState = {

    //COA Sidebar
    loadingCOASidebar: false,
    COASidebar: [],
    COASidebarError: '',

    loadingCOALedgerMasterDetail: true,
    COALedgerMasterDetail: {},
    COALedgerMasterDetailError: '',
}

const ChartOfAccountReducer = (state = initialState, action) => {
    switch (action.type) {


        //COA Sidebar//
        case 'FIND_COA_SIDEBAR_REQUEST':
            return {
                ...state,
                loadingCOASidebar: true,
                COASidebar: [],
                COASidebarError: '',
            };
        case 'FIND_COA_SIDEBAR_SUCCESS':
            return {
                ...state,
                loadingCOASidebar: false,
                COASidebar: action.payload.data,

            };
        case 'FIND_COA_SIDEBAR_FAILURE':
            return {
                ...state,
                loadingCOASidebar: false,
                COASidebarError: action.payload,
            };
        //COA Sidebar//


        //COA Sidebar//
        case 'FIND_COA_LEDGER_MASTER_DETAIL_REQUEST':
            return {
                ...state,
                loadingCOALedgerMasterDetail: true,
                COALedgerMasterDetail: {},
                COALedgerMasterDetailError: '',
            };
        case 'FIND_COA_LEDGER_MASTER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCOALedgerMasterDetail: false,
                COALedgerMasterDetail: action.payload.data,

            };
        case 'FIND_COA_LEDGER_MASTER_DETAIL_FAILURE':
            return {
                ...state,
                loadingCOALedgerMasterDetail: false,
                COALedgerMasterDetailError: action.payload,
                COALedgerMasterDetail: {},
            };
        //COA Sidebar//


        default:
            return state;
    }
}

export default ChartOfAccountReducer;